<div class="modal-dialog modal-xl modal-fullscreen-md-down modal-dialog-centered" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title" style="line-height:1.2;">
				<strong><%= terminal.site_name %><i class="fa fa-angle-right mx-2"></i><%= terminal.device_info.hostname || terminal.name %></strong><br />
				<small class="text-info" style="font-size:0.7em; font-weight:normal;"><%= terminal.company_name %></small>
			</h5>
			<button class="btn btn-link d-inline-block d-md-none" style="position:absolute; right:40px; top:18px;" data-bs-toggle="collapse" href="#terminal-extra-info"><i class="fa fa-fw fa-lg fa-info-circle"></i></button>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body p-0">
			<div class="container">
				<div class="row">

					<div class="col-12 col-md-auto p-0" style="background-color:var(--bs-gray-700);">
						<div class="collapse d-md-block" id="terminal-extra-info" style="min-width:250px;">

							<% if (terminal.name.startsWith('IMIN')) { %>
							<div class="text-center mt-2">
								<img src="/assets/terminal/imind2.png" class="img-fluid" /><br />
								<strong class="text-info">imin</strong>
							</div>
							<hr class="mx-4 mt-2 mb-0" style="background-color:rgba(0, 0, 0, 0.4);" />
							<% } else if (terminal.type == 'windows' && terminal.device_info.cpu[0].model.includes('J6412')) { %>
							<div class="text-center mt-2">
								<img src="/assets/terminal/posiflex16.png" class="img-fluid" /><br />
								<strong class="text-info">Posiflex PS-3616G2</strong>
							</div>
							<hr class="mx-4 mt-2 mb-0" style="background-color:rgba(0, 0, 0, 0.4);" />
							<% } else if (terminal.type == 'windows' && terminal.device_info.cpu[0].model.includes('J3455')) { %>
							<div class="text-center mt-2">
								<img src="/assets/terminal/posiflex16.png" class="img-fluid" /><br />
								<strong class="text-info">Posiflex PS-3616Q</strong>
							</div>
							<hr class="mx-4 mt-2 mb-0" style="background-color:rgba(0, 0, 0, 0.4);" />
							<% } %>

							<table class="mx-2 mt-2 mb-0" style="font-size:0.8em;">
								<tr>
									<td valign="top" style="width:75px;">Első indítás</td>
									<td class="text-info"><%= Anvil.moment(terminal.first_start).format('YYYY.MM.DD HH:mm:ss') %></td>
								</tr>
								<tr>
									<td valign="top">Utolsó indítás</td>
									<td class="text-info"><%= Anvil.moment(terminal.recent_start).format('YYYY.MM.DD HH:mm:ss') %></td>
								</tr>
								<tr>
									<td valign="top">Indítások</td>
									<td class="text-info"><%= terminal.startups %></td>
								</tr>
							</table>

							<hr class="mx-4 mt-2 mb-0" style="background-color:rgba(0, 0, 0, 0.4);" />

							<table class="mx-2 mt-2 mb-0" style="font-size:0.8em;">
								<% if (terminal?.settings?.peripherals?.ecr) { %>
								<tr>
									<td valign="top" style="width:75px;">Pénztárgép</td>
									<td class="text-info" valign="top">
										<%- terminal?.settings?.peripherals?.ecr?.type %><br />
										<strong><%- terminal?.settings?.peripherals?.ecr?.ap %></strong>
									</td>
								</tr>
								<% } else { %>
								<tr>
									<td valign="top">Pénztárgép</td>
									<td class="text-info"><strong><%= terminal.default_cashreg_ap %></strong></td>
								</tr>
								<% } %>

								<% for (const bct of (terminal?.settings?.peripherals?.bcts || [])) { %>
								<tr>
									<td valign="top" style="width:75px;">Bankkártya term.</td>
									<td class="text-info" valign="top">
										<strong><%- bct?.name %></strong><br />
										<%- bct?.bct_id %>
									</td>
								</tr>
								<% } %>

								<% if (terminal?.settings?.peripherals?.scale) { %>
								<tr>
									<td valign="top" style="width:75px;">Mérleg</td>
									<td class="text-info" valign="top">
										<%- terminal?.settings?.peripherals?.scale?.type %>
									</td>
								</tr>
								<% } %>
							</table>
							<% if (terminal.type == 'windows') { %>

							<hr class="mx-4 my-2" style="background-color:rgba(0, 0, 0, 0.4);" />

							<table class="mx-2 my-0" style="font-size:0.8em;">
								<tr>
									<td valign="top" style="width:17px;"><i class="fa fa-fw fa-hashtag"></i></td>
									<td class="text-info"><%- terminal.machine_id %></td>
								</tr>
								<tr>
									<td valign="top" style="width:17px;"><i class="fa fa-fw fa-microchip"></i></td>
									<td class="text-info"><%- terminal.device_info.cpu[0].model.split('@')[0] %></td>
								</tr>
								<tr>
									<td valign="top"><i class="fa fa-fw fa-memory"></i></td>
									<td class="text-info"><%= Anvil.numeral(terminal.device_info.memory.total).format('0.00 b') %> RAM</td>
								</tr>
								<%
								const ethernet_key = Object.keys(terminal.device_info.network).find(n => n.startsWith('Ethernet'))
								if (ethernet_key !== undefined) {
									const ipv4 = terminal.device_info.network[ethernet_key].find(x => x.family == 'IPv4')
								%>
								<tr>
									<td valign="top"><i class="fa fa-fw fa-ethernet"></i></td>
									<td class="text-info">
										<% if (ipv4) { %><%= ipv4.address %><% } %>
									</td>
								</tr>
								<% } else { %>
								<tr>
									<td valign="top" class="text-warning"><i class="fa fa-fw fa-ethernet"></i></td>
									<td class="text-warning">
										nincs ethernet
									</td>
								</tr>
								<% } %>
								<%
								const wifi_key = Object.keys(terminal.device_info.network).find(n => n.startsWith('Wi-Fi'))
								if (wifi_key !== undefined) {
									const ipv4 = terminal.device_info.network[wifi_key].find(x => x.family == 'IPv4')
								%>
								<tr>
									<td valign="top"><i class="fa fa-fw fa-wifi"></i></td>
									<td class="text-info">
										<% if (ipv4) { %><%= ipv4.address %><% } %>
									</td>
								</tr>
								<% } else { %>
								<tr>
									<td valign="top"><i class="fa fa-fw fa-wifi"></i></td>
									<td class="text-info">
										nincs wifi
									</td>
								</tr>
								<% } %>
								<tr>
									<td valign="top"><i class="fa fa-fw fa-hdd"></i></td>
									<td class="text-info">
									<% if (terminal.device_info.drive) { %>
										<%= Anvil.numeral(terminal.device_info.drive.free).format('0.00 b') %> szabad
									<% } else { %>
										ismeretlen
									<% } %>
									</td>
								</tr>
								<tr>
									<td valign="top"><i class="fab fa-fw fa-windows"></i></td>
									<td class="text-info"><%= terminal.device_info.os.version %> (<%= terminal.device_info.os.arch %>)<br /><%= terminal.device_info.os.release %></td>
								</tr>
							</table>

							<hr class="mx-4 my-2" style="background-color:rgba(0, 0, 0, 0.4);" />

							<%
							const operator_pass = (terminal.settings && terminal.settings.operator_pass) ? terminal.settings.operator_pass : '-'
							const admin_pass = (terminal.settings && terminal.settings.admin_pass) ? terminal.settings.admin_pass : '-'
							const db_pass = (terminal.config && terminal.config.database && terminal.config.database.db_password) ? terminal.config.database.db_password : '-'
							%>
							<table class="mx-2 mb-0 mt-2" style="font-size:0.8em;">
								<tr>
									<td valign="top" style="width:75px;">Op. jelszó</td>
									<td class="text-info"><%- operator_pass %></td>
								</tr>
								<tr>
									<td valign="top">Admin jelszó</td>
									<td class="text-info"><%- admin_pass %></td>
								</tr>
								<tr>
									<td valign="top">MySql jelszó</td>
									<td class="text-info"><%- db_pass %></td>
								</tr>
							</table>

							<% } %>

							<hr class="mx-4 my-2" style="background-color:rgba(0, 0, 0, 0.4);" />
							<div class="text-center mb-2">
								<strong style="color:goldenrod;"><%= Anvil.numeral(terminal.total_debit).format('0,0') %> Ft/hó</strong>
							</div>
						</div>
					</div>

					<div class="col p-0">

						<!-- Tab navigation -->
						<ul class="nav nav-pills m-2">
							<li class="nav-item">
								<button type="button" class="nav-link active" data-bs-toggle="tab" data-bs-target="#terminal-tab-base">Alapadatok</button>
							</li>
							<li class="nav-item">
								<button type="button" class="nav-link" data-bs-toggle="tab" data-bs-target="#terminal-tab-debit">Terhelések</button>
							</li>
							<li class="nav-item">
								<button type="button" class="nav-link" data-bs-toggle="tab" data-bs-target="#terminal-tab-ban">Tiltás</button>
							</li>
							<li class="flex-grow-1"></li>
							<li class="nav-item">
								<button type="button" class="nav-link" data-bs-toggle="tab" data-bs-target="#terminal-tab-settings"><i class="fa fa-fw fa-cog"></i><span class="d-none d-lg-inline ms-2">Helyi beállítások</span></button>
							</li>
							<li class="nav-item">
								<button type="button" class="nav-link" data-bs-toggle="tab" data-bs-target="#terminal-tab-scripts"><i class="fa fa-fw fa-scroll"></i><span class="d-none d-lg-inline ms-2">Scriptek</span></button>
							</li>
						</ul>

						<hr class="m-0" />

						<div class="tab-content" id="terminal-tab-content">

							<%
							const local_settings = {
								terminal_specific: { ...terminal.local_settings },
								general: { ...terminal.settings }
							};
							delete local_settings.general.payment_methods;

							const payment_methods = terminal?.settings?.payment_methods || [];
							// Sort payment_methods by ntak_type, order is: KESZPENZHUF, KESZPENZEUR, BANKKARTYA, others
							payment_methods.sort((a, b) => {
								const order = ['KESZPENZHUF', 'KESZPENZEUR', 'BANKKARTYA'];
								var aIndex = order.indexOf(a.ntak_type);
								if (aIndex === -1) aIndex = order.length;
								var bIndex = order.indexOf(b.ntak_type);
								if (bIndex === -1) bIndex = order.length;
								return aIndex - bIndex;
							});
							%>

							<div class="tab-pane p-3 show active" id="terminal-tab-base" tabindex="0">

								<%- include('/ui/form', {
									params: [ 'terminal', terminal, {
										width: 360
									} ],
									fields: [
										{ type: 'row', fields: [
											{ type: 'col', width: 7, responsive: true, fields: [
												{ type: 'fieldset', title: 'Beállítások', fields: [
													{
														type: 'switch',
														name: 'archive',
														title: 'Archív',
														description: 'A terminál nincs aktív jogviszonyban.'
													},

													/*
													{
														type: 'text',
														variant: 'number',
														name: 'licence_fee',
														title: 'Havi díj'
													},
													{
														type: 'text',
														variant: 'number',
														name: 'partner_dividend',
														title: 'Partner jutaléka'
													},
													*/

													{
														type: 'text',
														name: 'anydesk_id',
														title: 'Anydesk ID'
													},
													{
														type: 'select_simple',
														name: 'update_channel',
														title: 'Frissítési csatorna',
														options: [
															[ 'disabled', 'Ne frissüljön' ],
															[ 'stable', 'Stabil verzió' ],
															[ 'beta', 'Béta verzió' ],
															[ 'alpha', 'Alpha verzió' ]
														]
													},
													{
														type: 'select_simple',
														name: 'force_ntak',
														title: 'NTAK élesítés',
														options: [
															[ 0, 'Nem' ],
															[ 1, 'Élesítse most!' ]
														],
														help: 'Ez jelet küld a terminálnak, hogy azonnal álljon át NTAK jelentés módba. Nap nyitás előtt lenne jó.'
													}
												]},
											]},
											{ type: 'col', width: 5, responsive: true, fields: [
												{ type: 'fieldset', title: 'Megjegyzések', fields: [
													{
														type: 'textarea',
														name: 'notes',
														inline: true,
														title: 'Megjegyzések',
														attributes: {
															style: 'height:470px;'
														}
													}
												]},
											]}
										]}
									]
								}) %>

							</div>

							<div class="tab-pane p-3" id="terminal-tab-debit" tabindex="0">

								<legend>Havidíjak (számlázás <%- { monthly: 'havonta', quarterly: 'negyedévente', 'half-yearly': 'félévente', annual: 'évente' }[terminal.company_invoicing_period] %>)</legend>

								<div class="row text-dim">
									<div class="col-12 col-xl-5 py-2">Megnevezés</div>
									<div class="col-12 col-xl-7">
										<div class="row g-1 mb-2">
											<div class="col py-2">Kezdő dátum</div>
											<div class="col py-2">Vég dátum</div>
											<div class="col-auto py-2" style="width:94px;">Díj</div>
											<div class="col-auto py-2" style="width:94px;">Jutalék</div>
											<div class="col-auto py-2" style="width:40px;"></div>
										</div>
									</div>
								</div>

								<%- include('/ui/form_array', {
									prefix: 'terminal_debit',
									data: terminal,
									model: Anvil.models.c_order.RecurringDebit,
									name: 'recurring_debits',
									placeholder: '-- Még nincs megadva egyetlen költség sem --',
									fields: [
										{ type: 'row', fields: [
											{ type: 'col', responsive: true, width: 5, fields: [
												{
													type: 'group',
													no_label: true,
													fields: [
														{
															type: 'select',
															name: 'debit_type',
															title: 'Típus',
															params: {
																maxItems: 1,
																options: debit_types.data,
																valueField: 'id',
																labelField: 'name',
																searchField: [ 'name' ],
																render: {
																	item: (item, esc) => `<div>${esc(item.name)}${item.mediated_service ? ' <div class="badge bg-primary">K.Sz.</div>' : ''}</div>`,
																	option: (item, esc) => `<div class="option">${esc(item.name)}${item.mediated_service ? ' <div class="badge bg-primary">K.Sz.</div>': ''}</div>`
																}
															}
														}
													]
												}
											]},
											{ type: 'col', responsive: true, width: 7, fields: [
												{
													type: 'group',
													no_label: true,
													fields: [
														{
															type: 'date',
															name: 'start_d',
															title: 'Kezdő dátum'
														},
														{
															type: 'date',
															name: 'end_d',
															title: 'Vég dátum'
														},
														{
															type: 'text',
															variant: 'number',
															name: 'amount',
															title: 'Összeg',
															width: 'auto',
															attributes: {
																style: 'width:90px;'
															}
														},
														{
															type: 'text',
															variant: 'number',
															name: 'dividend',
															title: 'Jutalék',
															width: 'auto',
															attributes: {
																style: 'width:90px;'
															}
														},
														{
															type: 'html',
															content: `<div class="col-auto"><button type="button" class="remove-btn btn btn-dark text-danger"><i class="fa fa-times"></i></button></div>`
														}
													]
												}
											]}
										]}
									]
								}) %>

								<!--
								<legend>Egyszeri díjak</legend>

								<div class="row text-dim">
									<div class="col">
										<div class="row g-1 mb-2">
											<div class="col ps-1" style="min-width:290px;">Megnevezés</div>
											<div class="col-auto ps-1" style="width:114px;">Dátum</div>
											<div class="col-auto ps-1" style="width:124px;">Díj</div>
											<div class="col-auto ps-1" style="width:40px;"></div>
										</div>
									</div>
								</div>

								<%- include('/ui/form_array', {
									prefix: 'terminal_debit',
									data: terminal,
									model: Anvil.models.c_order.OneTimeDebit,
									name: 'one_time_debits',
									placeholder: '-- Még nincs megadva egyetlen költség sem --',
									fields: [
										{
											type: 'group',
											no_label: true,
											fields: [
												{
													type: 'select',
													name: 'debit_type',
													title: 'Típus',
													params: {
														maxItems: 1,
														options: debit_types.data,
														valueField: 'id',
														labelField: 'name',
														searchField: [ 'name' ],
														/*
														render: {
															item: (item, esc) => `<div>${esc(item.name)}<br /><small><i class="fa fa-fw fa-sm fa-${Anvil.models.c_order.Site.Types.find(t => t.value == item.site_type).icon} me-1"></i>${esc(item.site_name)}</small></div>`,
															option: (item, esc) => `<div class="option">${esc(item.name)}<br /><small><i class="fa fa-fw fa-sm fa-${Anvil.models.c_order.Site.Types.find(t => t.value == item.site_type).icon} me-1"></i>${esc(item.site_name)}</small></div>`
														}
														*/
													},
												},
												{
													type: 'date',
													name: 'start_d',
													title: 'Dátum',
													width: 'auto',
													attributes: {
														style: 'width:110px;'
													}
												},
												{
													type: 'text',
													variant: 'number',
													name: 'amount',
													title: 'Összeg',
													width: 'auto',
													attributes: {
														style: 'width:120px;'
													}
												},
												{
													type: 'html',
													content: `<div class="col-auto"><button type="button" class="remove-btn btn btn-dark text-danger"><i class="fa fa-times"></i></button></div>`
												}
											]
										}
									]
								}) %>
								-->

							</div>

							<div class="tab-pane p-3" id="terminal-tab-ban" tabindex="0">

								<%- include('/ui/form', {
									params: [ 'remote_settings', terminal.remote_settings, {
										width: 360
									} ],
									fields: [
										{ type: 'row', fields: [
											{ type: 'col', width: 7, responsive: true, fields: [
												{
													type: 'select_simple',
													name: 'warning_mode',
													title: 'Figyelmeztetés módja',
													options: [
														[ 'none', 'Nincs' ],
														[ 'warning', 'Rendelés lezárásakor mutassa az üzenetet' ],
														[ 'ban', 'Ne engedjen rendelést lezárni, figyelmeztessen' ]
													]
												},
												{
													type: 'textarea',
													name: 'warning_message',
													title: 'Figyelmeztető üzenet',
													attributes: {
														style: 'height:275px;'
													}
												}
											]}
										]}
									]
								}) %>

								<%- include('/ui/form', {
									params: [ 'terminal_unlock', terminal, {
										width: 360
									} ],
									fields: [
										{ type: 'row', fields: [
											{ type: 'col', width: 7, responsive: true, fields: [
												{
													type: 'text',
													name: 'unlock_code',
													title: 'Feloldó kód',
													help: 'Ezt a kódot kell megadni a figyelmeztető üzenet vagy tiltás feloldásához',
													attributes: {
														readonly: true
													}
												}
											]}
										]}
									]
								}) %>

							</div>

							<div class="tab-pane p-3" id="terminal-tab-settings" tabindex="0">

								<%- include('/c_order/terminal/panel_payment_methods', { payment_methods }) %>

								<fieldset class="mt-3">
									<legend class="mb-3">Beállítások</legend>

									<pre><%- JSON.stringify(local_settings, null, 2).replaceAll('\n', '<br />') %></pre>
								</fieldset>
							</div>

							<div class="tab-pane p-3" id="terminal-tab-scripts" tabindex="0">

								<fieldset>
									<legend class="mb-1">
										Script futtatás
										<button class="btn btn-sm btn-warning float-end mb-1" id="enqueue-instruction-btn" onclick="Anvil.page.modal.enqueue_instruction()"><i class="fa fa-paper-plane me-2"></i>Feladás</button>
									</legend>

									<%- include('/ui/form', {
										params: [ 'script', instruction_form ],
										fields: [
											{
												type: 'textarea',
												name: 'code',
												inline: true,
												title: 'Utasítások',
												attributes: {
													style: 'height:240px;'
												}
											}
										]
									}) %>
								</fieldset>

								<fieldset class="mt-3">
									<legend class="mb-1">
										Napló
										<button class="btn btn-sm btn-primary float-end mb-1" id="enqueue-instruction-btn" onclick="Anvil.page.modal.refresh_instructions()"><i class="fa fa-sync-alt me-2"></i>Frissítés</button>
									</legend>

									<%- include('/c_order/terminal/panel_instructions', { instructions }) %>
								</fieldset>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer justify-content-between">
			<div>
				<div class="dropup float-start me-1">
					<button class="btn btn-dark" data-bs-toggle="dropdown" data-bs-auto-close="outside"><i class="fa fa-fw fa-caret-up"></i></button>
					<ul class="dropdown-menu">
						<li><button type="button" class="dropdown-item py-2" onclick="Anvil.page.modal.close(); Anvil.exec('company/modal_edit', <%- terminal.company_id %>)"><i class="fa fa-fw fa-building me-3"></i><%- terminal.company_name %></button></li>
						<li><button type="button" class="dropdown-item py-2" onclick="Anvil.page.modal.close(); Anvil.exec('c_order/company_db/modal_edit', <%- terminal.company_db_id %>)"><i class="fa fa-fw fa-database me-3"></i><%- terminal.company_db_name %></button></li>
						<li><button type="button" class="dropdown-item py-2" onclick="Anvil.page.modal.close(); Anvil.exec('c_order/site/modal_edit', <%- terminal.company_db_id %>, <%- terminal.site_id %>)"><i class="fa fa-fw fa-<%- Anvil.models.c_order.Site.Types.find(t => t.value == terminal.site_type).icon %> me-3"></i><%- terminal.site_public_name || terminal.site_name %></button></li>
						<li><button type="button" class="dropdown-item py-2 disabled"><i class="fa-fw <% if (terminal.type == 'android') { %>fab fa-android<% } else { %>fa fa-desktop<% } %> me-3"></i><%- terminal.name %></button></li>
						<% if (terminal.aee_id) { %>
						<li><button type="button" class="dropdown-item py-2" onclick="Anvil.page.modal.close(); Anvil.exec('c_order/aee/modal_edit', <%- terminal.aee_id %>)"><i class="fa fa-fw fa-cash-register me-3"></i><%- terminal.default_cashreg_ap %></button></li>
						<% } %>
					</ul>
				</div>
				<button type="button" class="btn btn-dark <% if (terminal.anydesk_id) { %>text-warning<% } else { %>disabled text-dim<% } %>" onclick="Anvil.page.modal.connect_with_anydesk()"><i class="fa fa-headset me-2"></i>Távsegítség</button>
				<button type="button" class="btn btn-dark" style="color:tan;" onclick="Anvil.page.modal.issue()"><i class="fa fa-briefcase me-2"></i>Új munkalap</button>
			</div>

			<button type="button" class="btn btn-primary" onclick="Anvil.page.modal.save()"><i class="fa fa-check me-2"></i>Mentés</button>
		</div>
	</div>
</div>
<script>
Anvil.page.modal = Object.assign(Anvil.page.modal, {

	async connect_with_anydesk (machine_id) {

		Anvil.page.modal.close()

		// Find terminal
		const terminal = Anvil.page.modal.terminal
		if (terminal !== undefined) {
			// Request confirmation
			Anvil.confirm({
				title: 'Anydesk kapcsolat',
				message: `
					<p>Biztosan szeretnél csatlakozni a kiválasztott terminálhoz?</p>
					<table style="font-size:0.9em;">
						<tr>
							<td class="pe-3">Cég</td>
							<td><strong>${terminal.company_name}</strong></td>
						</tr>
						<tr>
							<td class="pe-3">Telephely</td>
							<td><strong>${terminal.site_name}</strong></td>
						</tr>
						<tr>
							<td class="pe-3" valign="top">Terminál</td>
							<td><strong>${terminal.device_info.hostname || terminal.name}</strong><br /><br /></td>
						</tr>
						<tr>
							<td class="pe-3">Anydesk ID</td>
							<td><strong>${terminal.anydesk_id}</strong></td>
						</tr>
					</table>
				`,
				btn_ok: `<i class="fa fa-headset me-2"></i>Csatlakozás`,
				btn_cancel: `<i class="fa fa-running me-2"></i>Mégse`,
				btn_ok_class: 'warning',
				onclose: (confirmed) => {
					if (confirmed) {
						window.open(`anydesk:${terminal.anydesk_id}`, '_self')
					}
				}
			})
		}
	},

	issue () {
		Anvil.page.modal.close()
		Anvil.exec('issue/modal_edit', null, {
			link: 'terminal',
			company_id: Anvil.page.modal.terminal.company_id,
			company_db_id: Anvil.page.modal.terminal.company_db_id,
			site_id: Anvil.page.modal.terminal.site_id,
			terminal_id: Anvil.page.modal.terminal.machine_id
		})
	},

	async save () {
		const res = await Anvil.exec('c_order/terminal/action_save', Anvil.page.modal.terminal)

		// Close modal
		if (res === true) Anvil.page.modal.close()
	},

	async refresh_instructions () {
		await Anvil.exec('c_order/terminal/refresh_instructions')
	},

	async enqueue_instruction () {
		const form = Anvil.page.modal.instruction_form
		const res = await Anvil.exec('c_order/terminal/action_enqueue_instruction', form.code)
	}
})
</script>
